module.exports = __webpack_public_path__ + "static/img/claim@2x.c66ce517.png";